export const TopSliderItems = [
    {
        id: 1,
        image: {
            background: "linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2)), url(https://floriaro.vtexassets.com/assets/vtex.file-manager-graphql/images/afc42804-f9ed-4775-93b6-58f62559e2cc___3bb99174ea5e8e088ac830b40343f75d.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        },
        title: "Vezi colectia de vara",
        path: "/Buchete-flori/Flori-de-Vara"
    },
    {
        id: 2,
        image: {
            background: "linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2)), url(https://floriaro.vtexassets.com/assets/vtex.file-manager-graphql/images/c9186214-5a84-4da1-81ed-fc893bd175e9___43a10352c04dc9997eecba1ebaf3be04.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        },
        title: "Buchete cu floarea soarelui",
        path: "/Buchete-flori/Flori-de-Vara"
    },
    {
        id: 3,
        image: {
            background: "linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2)), url(https://floriaro.vtexassets.com/assets/vtex.file-manager-graphql/images/71b98ac0-63e8-432e-bb82-4918a78c6a1d___535a9d88795aa0112d6a92f6b48311aa.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        },
        title: "Buchete cu hortensie",
        path: "/Buchete-flori/Buchete-cu-Hortensie"
    },
    {
        id: 4,
        image: {
            background: "linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2)), url(https://floriaro.vtexassets.com/assets/vtex.file-manager-graphql/images/c5514692-173c-43e2-9de4-be0d846765c7___0fa95d03e27116fac51d0067eab97924.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        },
        title: "Flori pentru onomastica",
        path: "/Ocazii-si-evenimente/Flori-Onomastica"
    },
]